import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import API_CONFIG2 from '../../API_CONFIG/API_CONFIG2';
import Logo from '../../../assetes/logos.png';

const API_RAPPORT = `${API_CONFIG2.apiUrl}mission/api_rapport_mission2.php`;

const RapportMissionModal2 = ({ show, handleClose, missionId, rapportId: initialRapportId }) => {
  const [loading, setLoading] = useState(false);
  const [rapport, setRapport] = useState(null);
  const [error, setError] = useState(null);

  const fetchRapport = async (url) => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(url);
      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        throw new Error(`Réponse non-JSON : ${text.substring(0, 200)}`);
      }
      if (!res.ok) throw new Error(`HTTP ${res.status} : ${data.message || ''}`);
      if (data.status === 'success') {
        setRapport(data.data);
      } else {
        setError(data.message || 'Erreur de chargement');
      }
    } catch (err) {
      setError('Erreur réseau : ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
   if (!show) return;
    if (missionId) {
      fetchRapport(`${API_RAPPORT}?action=fetch_by_mission&missionId=${missionId}`);
    } else if (initialRapportId) {
      fetchRapport(`${API_RAPPORT}?action=fetch&id=${initialRapportId}`);
    }
  }, [show, missionId, initialRapportId]);

  const generatePDF = async () => {
    const content = document.getElementById('rapport-content');
    if (!content) return;
    try {
      const canvas = await html2canvas(content, {
        scale: 2,
        backgroundColor: '#ffffff',
        logging: false,
        allowTaint: true,
        useCORS: true,
      });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      pdf.save(`rapport_mission_${rapport?.id || 'inconnu'}.pdf`);
    } catch (err) {
      console.error('Erreur génération PDF', err);
    }
  };

  // --- Gestion des états d'affichage ---
  if (!show) return null;

  if (!missionId && !initialRapportId) {
    return (
      <Modal show={show} onHide={handleClose} size="lg" centered className="rapport-modal">
        <Modal.Header closeButton className="modal-header-custom">
          <Modal.Title>Rapport de Mission</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body-custom">
          <p className="text-center text-muted" style={{ padding: '2rem 0' }}>
            Aucun identifiant de mission fourni.
          </p>
        </Modal.Body>
        <Modal.Footer className="modal-footer-custom">
          <Button variant="secondary" onClick={handleClose}>Fermer</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  if (loading) {
    return (
      <Modal show={show} onHide={handleClose} size="lg" centered className="rapport-modal">
        <Modal.Body className="modal-body-custom text-center py-5">
          <Spinner animation="border" variant="primary" className="custom-spinner" />
          <p className="mt-3 text-muted">Chargement du rapport...</p>
        </Modal.Body>
      </Modal>
    );
  }

  if (error) {
    return (
      <Modal show={show} onHide={handleClose} size="lg" centered className="rapport-modal">
        <Modal.Body className="modal-body-custom text-center py-4">
          <p className="text-danger">{error}</p>
          <Button variant="secondary" onClick={handleClose}>Fermer</Button>
        </Modal.Body>
      </Modal>
    );
  }

  if (!rapport) {
    return (
      <Modal show={show} onHide={handleClose} size="lg" centered className="rapport-modal">
        <Modal.Header closeButton className="modal-header-custom">
          <Modal.Title>Rapport de Mission</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body-custom">
          <p className="text-center text-muted" style={{ padding: '2rem 0' }}>
            Aucun rapport trouvé pour cette mission.
          </p>
        </Modal.Body>
        <Modal.Footer className="modal-footer-custom">
          <Button variant="secondary" onClick={handleClose}>Fermer</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // --- Styles CSS (inchangés, mais toujours présents) ---
   const styles = `
    .rapport-modal .modal-content {
      border-radius: 16px;
      border: none;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
      overflow: hidden;
    }

    .modal-header-custom {
      background: linear-gradient(135deg, #1a365d 0%, #2b6cb0 100%);
      color: white;
      border-bottom: none;
      padding: 1.25rem 2rem;
    }

    .modal-header-custom .modal-title {
      font-weight: 600;
      font-size: 1.4rem;
      letter-spacing: -0.3px;
      color: white;
    }

    .modal-header-custom .btn-close {
      filter: brightness(0) invert(1);
      opacity: 0.8;
    }

    .modal-body-custom {
      padding: 2rem;
      background: #f8fafc;
    }

    .modal-footer-custom {
      background: #f8fafc;
      border-top: 1px solid #e2e8f0;
      padding: 1rem 2rem;
    }

    /* Contenu du rapport */
    #rapport-content {
      font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
      color: #1a202c;
      background: white;
      border-radius: 12px;
      padding: 2rem 2rem 1.5rem;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
    }

    .rapport-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      padding-bottom: 1.25rem;
      margin-bottom: 1.75rem;
      border-bottom: 2px solid #edf2f7;
    }

    .rapport-header-left {
      display: flex;
      align-items: center;
      gap: 1rem;
    }

    .rapport-header-left img {
      height: 48px;
      object-fit: contain;
    }

    .rapport-header-left h2 {
      font-size: 1.6rem;
      font-weight: 700;
      color: #1a365d;
      margin: 0;
      letter-spacing: -0.5px;
    }

    .rapport-header-right {
      text-align: right;
      color: #4a5568;
      font-size: 0.85rem;
    }

    .rapport-header-right .date {
      font-weight: 500;
      color: #2b6cb0;
    }

    .section-card {
      background: #ffffff;
      border-radius: 10px;
      padding: 1.25rem 1.5rem;
      margin-bottom: 1.25rem;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
      border-left: 4px solid #2b6cb0;
      transition: box-shadow 0.2s;
    }

    .section-card:hover {
      box-shadow: 0 4px 16px rgba(43, 108, 176, 0.06);
    }

    .section-title {
      font-size: 1rem;
      font-weight: 600;
      color: #1a365d;
      margin-bottom: 1rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .section-title .icon {
      font-size: 1.2rem;
    }

    .info-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0.75rem 2rem;
    }

    .info-item {
      display: flex;
      flex-direction: column;
    }

    .info-item .label {
      font-size: 0.7rem;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: #718096;
      font-weight: 600;
    }

    .info-item .value {
      font-size: 0.95rem;
      font-weight: 500;
      color: #2d3748;
      margin-top: 0.1rem;
      word-break: break-word;
    }

    .info-item .value.badge-status {
      display: inline-block;
      background: #e2e8f0;
      color: #2d3748;
      padding: 0.2rem 0.8rem;
      border-radius: 20px;
      font-size: 0.75rem;
      font-weight: 600;
      text-transform: uppercase;
      width: fit-content;
    }

    .info-item .value.badge-status.success {
      background: #c6f6d5;
      color: #276749;
    }

    .info-item .value.badge-status.warning {
      background: #fefcbf;
      color: #975a16;
    }

    .info-item .value.badge-status.danger {
      background: #fed7d7;
      color: #9b2c2c;
    }

    .notes-section {
      margin-top: 0.5rem;
    }

    .notes-section .label {
      font-size: 0.7rem;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: #718096;
      font-weight: 600;
    }

    .notes-section .value {
      font-size: 0.95rem;
      color: #2d3748;
      margin-top: 0.2rem;
    }

    .rapport-footer {
      margin-top: 1.5rem;
      padding-top: 1rem;
      border-top: 1px solid #edf2f7;
      text-align: center;
      color: #a0aec0;
      font-size: 0.75rem;
      letter-spacing: 0.3px;
    }

    /* Bouton PDF personnalisé */
    .btn-pdf {
      background: #1a365d;
      border: none;
      color: white;
      padding: 0.5rem 1.5rem;
      border-radius: 50px;
      font-weight: 500;
      transition: all 0.2s;
    }

    .btn-pdf:hover {
      background: #2b6cb0;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(26, 54, 93, 0.2);
    }

    .btn-pdf:active {
      transform: translateY(0);
    }

    .btn-secondary-custom {
      border-radius: 50px;
      padding: 0.5rem 1.5rem;
      font-weight: 500;
      border: 1px solid #e2e8f0;
      background: white;
      color: #4a5568;
      transition: all 0.2s;
    }

    .btn-secondary-custom:hover {
      background: #f7fafc;
      border-color: #cbd5e0;
    }

    /* Spinner personnalisé */
    .custom-spinner {
      width: 3rem;
      height: 3rem;
      border-width: 0.25rem;
    }

    /* Responsive */
    @media (max-width: 576px) {
      .rapport-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
      }
      .rapport-header-right {
        text-align: left;
        width: 100%;
      }
      .info-grid {
        grid-template-columns: 1fr;
        gap: 0.5rem;
      }
      .modal-body-custom {
        padding: 1rem;
      }
      #rapport-content {
        padding: 1rem;
      }
      .section-card {
        padding: 1rem;
      }
    }
  `;

  // Fonction getStatusBadgeClass (inchangée)
  const getStatusBadgeClass = (statut) => {
    if (!statut) return '';
    const lower = statut.toLowerCase();
    if (lower.includes('terminé') || lower.includes('validé') || lower.includes('approuvé')) return 'success';
    if (lower.includes('en cours') || lower.includes('attente')) return 'warning';
    if (lower.includes('annulé') || lower.includes('rejeté')) return 'danger';
    return '';
  };

  return (
    <>
      <style>{styles}</style>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        centered
        className="rapport-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="modal-header-custom">
          <Modal.Title>Rapport de Mission</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body-custom">
          <div id="rapport-content">
            {/* En-tête */}
            <div className="rapport-header">
              <div className="rapport-header-left">
                <img src={Logo} alt="Logo" />
                <h2>Rapport de Mission</h2>
              </div>
              <div className="rapport-header-right">
                <div className="date">📅 {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
                <div style={{ fontSize: '0.75rem', color: '#a0aec0' }}>Réf. {rapport.id || 'N/A'}</div>
              </div>
            </div>

            {/* Carte : Entreprise */}
            <div className="section-card">
              <div className="section-title">
                <span className="icon">🏢</span> Informations de l'entreprise
              </div>
              <div className="info-grid">
                <div className="info-item">
                  <span className="label">Nom</span>
                  <span className="value">{rapport.nomEntreprise || 'Non renseigné'}</span>
                </div>
                <div className="info-item">
                  <span className="label">Email</span>
                  <span className="value">{rapport.email || 'Non renseigné'}</span>
                </div>
                <div className="info-item">
                  <span className="label">Téléphone</span>
                  <span className="value">{rapport.telephone || 'Non renseigné'}</span>
                </div>
                <div className="info-item">
                  <span className="label">Secteur d'activité</span>
                  <span className="value">{rapport.secteur_activite || 'Non renseigné'}</span>
                </div>
                <div className="info-item" style={{ gridColumn: '1 / -1' }}>
                  <span className="label">Adresse</span>
                  <span className="value">{rapport.adresse || 'Non renseignée'}</span>
                </div>
              </div>
            </div>

            {/* Carte : Mission */}
            <div className="section-card">
              <div className="section-title">
                <span className="icon">📋</span> Détails de la mission
              </div>
              <div className="info-grid">
                <div className="info-item" style={{ gridColumn: '1 / -1' }}>
                  <span className="label">Mission</span>
                  <span className="value">{rapport.mission || 'Non renseignée'}</span>
                </div>
                <div className="info-item">
                  <span className="label">Dates</span>
                  <span className="value">{rapport.mission_dates || 'Non renseignées'}</span>
                </div>
                <div className="info-item">
                  <span className="label">Type de mission</span>
                  <span className="value">{rapport.type_mission || 'Non renseigné'}</span>
                </div>
                <div className="info-item">
                  <span className="label">Cible</span>
                  <span className="value">{rapport.cible || 'Non renseignée'}</span>
                </div>
                <div className="info-item">
                  <span className="label">Statut</span>
                  <span className={`value badge-status ${getStatusBadgeClass(rapport.statut)}`}>
                    {rapport.statut || 'Non défini'}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Date du rapport</span>
                  <span className="value">{rapport.dates || 'Non renseignée'}</span>
                </div>
              </div>
            </div>

            {/* Carte : Notes et commentaire */}
            <div className="section-card">
              <div className="section-title">
                <span className="icon">✍️</span> Évaluation & commentaire
              </div>
              <div className="info-grid">
                <div className="info-item">
                  <span className="label">Note /10</span>
                  <span className="value" style={{ fontWeight: '700', color: '#2b6cb0' }}>
                    {rapport.notes ? `${rapport.notes}/10` : 'Non noté'}
                  </span>
                </div>
                <div className="info-item" style={{ gridColumn: '1 / -1' }}>
                  <span className="label">Commentaire</span>
                  <span className="value">{rapport.commentaire || 'Aucun commentaire'}</span>
                </div>
              </div>
            </div>

            {/* Pied de page */}
            <div className="rapport-footer">
              Document généré automatiquement · Confidentiel
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer-custom">
          <Button variant="secondary" onClick={handleClose} className="btn-secondary-custom">
            Fermer
          </Button>
          <Button variant="primary" onClick={generatePDF} className="btn-pdf">
            ⬇ Télécharger PDF
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RapportMissionModal2;